import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SurveyTemplateCard extends Component {
  render() {
    const { surveyTemplate, isSelected, selectSurvey, viewSurveyDetail } = this.props;
    const templateName = surveyTemplate? surveyTemplate.name: 'Blank Survey';
    const templateDescription = surveyTemplate? surveyTemplate.description: '';

    return (
      <div className="col-xs-12 col-sm-6 col-md-4">
        <div className="soono-card-container">
          <div className="card shadow">
            <div className="card-header card-title">
                {templateName}
            </div>
            <div className="card-body py-0">
              <div>
                {templateDescription}
              </div>
            </div>
            <div className="card-footer">
              <div className="row">
                    <div className="col-md-4 col-sm-6 mx-0 pr-md-1">
                      <button
                        className="btn btn-sm btn-block detail-btn"
                        onClick={() => viewSurveyDetail(surveyTemplate)}
                      >
                        Details
                      </button>
                    </div>
                    <div className="col-md-4 col-sm-6 mx-0 pl-md-1">
                      <button
                        className={`btn btn-sm btn-block ${isSelected ? 'selected-btn': 'select-btn'}`}
                        onClick={() => selectSurvey(surveyTemplate)}
                      >
                        {isSelected ? 'Selected' : 'Select'}
                      </button>
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SurveyTemplateCard.propTypes = {
  surveyTemplate: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string
  }),
  isSelected: PropTypes.bool,
  selectSurvey: PropTypes.func,
  viewSurveyDetail: PropTypes.func
};

export default SurveyTemplateCard;



// WEBPACK FOOTER //
// ./src/components/survey-templates/SurveyTemplateCard.js